import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {

  connect() {
    this.sortable = Sortable.create(this.element, {
      onEnd: this.end.bind(this)
    })
  }

  end(event) {
    let url_token = event.item.dataset.url_token
    let data = new FormData()
    data.append("position", event.newIndex + 1)
    Rails.ajax({
      url: this.data.get("url").replace(':url_token', url_token),
      type: 'PATCH',
      data : data
    })
  }
}
